import React from "react";
import "./YoutubeVideo.scss";

export default function YoutubeVideo({ videoId, title = "YouTube Video" }) {
  // Extract video ID from YouTube URL if full URL is provided
  const getVideoId = (url) => {
    if (!url) return null;
    
    // Handle different YouTube URL formats
    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
      /youtube\.com\/watch\?.*v=([^&\n?#]+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) return match[1];
    }
    
    return url; // Return as-is if it's already just an ID
  };

  const videoIdFromUrl = getVideoId(videoId);
  
  if (!videoIdFromUrl) {
    return <div className="youtube-error">Invalid YouTube URL</div>;
  }

  return (
    <div className="youtube-container">
      <iframe
        className="youtube-iframe"
        src={`https://www.youtube.com/embed/${videoIdFromUrl}?start=17`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}
